awardCalculation.classy.controller({
    name: 'ImputedIncomeController',
    inject: ['$scope', '$http', 'RestService', 'ApplicationService', 'SchoolModelService', 'SliderService', 'SliderFactory', 
        'CalculationService', 'ModelService', 'PulsateService', 'BinFactory', '$timeout', 'DateService', 'TabsService', 'ResetService'],
    init: function()
    {
        this.$.ApplicationService = this.ApplicationService;
        this.$.assetOpen = false;
        this.$.liabilitiesOpen = false;
        this.$.PulsateService = this.PulsateService;
        this.$.versionNo = versionNo;
        this.$.isArchive = this.BinFactory.isArchive();
        this.$.item = this.SchoolModelService.data[0];
        this.$.DateService = this.DateService;
        this.$.TabsService = this.TabsService;
        this.$.ResetService = this.ResetService;
        this.$.year = this.ApplicationService.getAwardData().app[0].App_Fin_Year;
        this.$timeout(function() {
            var $window = $(window).on('resize', function(){
                var height = $(this).height() - 206;
                var slideoutTabWidth = $(".slideout-tabs").width();
                $(".slideout-tabs .nav-tabs").css("width", slideoutTabWidth + 'px');
            }).trigger('resize');
            var slideoutTabHeight = $(".slideout-tabs .nav-tabs").height();
            $(".data-start").css("margin-top", slideoutTabHeight + 'px');
        }, 300);

        var self = this;
        this.$.$on('openDrawerHighLight', function(event, data)
        {
            if (data.drawer == 'assets')
            {
                self.$.setAssetOpen(true);
            }
            else if (data.drawer == 'liabilities')
            {
                self.$.setLiabilitiesOpen(true);
            }
        });

    },
    setAssetOpen: function(value)
    {
        if (value==true) 
            this.SliderService.pushSlider(new this.SliderFactory('tabs/submodules/awardCalculation/partials/assets', 'Assets', 's'));
        else
            this.SliderService.pushSlider(new this.SliderFactory('tabs/submodules/awardCalculation/partials/imputedIncome', 'Imputed Income', 's'));
        this.$.assetOpen = value;
    },
    getAssetOpen: function()
    {
        return this.$.assetOpen;
    },
    setLiabilitiesOpen: function(value)
    {
        if (value==true) 
            this.SliderService.pushSlider(new this.SliderFactory('tabs/submodules/awardCalculation/partials/liabilities', 'Liabilities', 's'));
        else
            this.SliderService.pushSlider(new this.SliderFactory('tabs/submodules/awardCalculation/partials/imputedIncome', 'Imputed Income', 's'));
        this.$.liabilitiesOpen = value;
    },
    getLiabilitiesOpen: function()
    {
        return this.$.liabilitiesOpen;
    },
    assetsPut: function(scope, instance, form)
    {
        instance.options.factor = .3;
        var putData = {};
        var data = this.ApplicationService.getFamilyData().edit_sums;
        putData.Rea_PMV = data.Rea_PMV;
        putData.Oth_PMV = data.Oth_PMV;
        putData.Veh_EMV = data.Veh_EMV;
        putData.Asset_Savings = data.Asset_Savings;
        putData.Asset_Checking = data.Asset_Checking;
        putData.Asset_Deposit = data.Asset_Deposit;
        putData.Asset_Securities = data.Asset_Securities;
        putData.Asset_Trust_Val = data.Asset_Trust_Val;
        putData.Asset_Bus_Val = data.Asset_Bus_Val;
        putData.Asset_Ret_Sav = data.Asset_Ret_Sav;
        putData.Asset_Other_Val = data.Asset_Other_Val;
        this.ModelService.EditSumsService.putHelper(data, putData, this.CalculationService.reCalc).then(function() {
            instance.stop(1);
        });
    },
    liabilitiesPut: function(scope, instance, form)
    {
        instance.options.factor = .3;
        var putData = {};
        var data = this.ApplicationService.getFamilyData().edit_sums;
        putData.Rea_Principle = data.Rea_Principle;
        putData.Oth_Principle = data.Oth_Principle;
        putData.Veh_Debt_Out = data.Veh_Debt_Out;
        putData.Liab_Personal_Loan = data.Liab_Personal_Loan;
        putData.Liab_Credit = data.Liab_Credit;
        putData.Liab_Equity_Loan = data.Liab_Equity_Loan;
        putData.Liab_Other_Val = data.Liab_Other_Val;
        this.ModelService.EditSumsService.putHelper(data, putData, this.CalculationService.reCalc).then(function() {
            instance.stop(1);
        });
    },
    imputedIncomePut: function(scope, instance, form)
    {
        var putData = {};
        var data = this.ApplicationService.getFamilyData().thresholds;
        putData.Retire = data.Retire;
        putData.Equity = data.Equity;
        putData.Thresh_Assets_Cap = data.Thresh_Assets_Cap;
        putData.Thresh_Assets_Percent = data.Thresh_Assets_Percent;
        this.ModelService.FamilyThresholdsService.putHelper(data, putData, this.CalculationService.reCalc).then(function() {
            instance.stop(1);
        });
    },
    startSaveProcess: function(scope, instance, form)
    {
        instance.options.factor  = .3;
        var self = this;

        var putData = {};
        var data = this.ApplicationService.getFamilyData().thresholds;
        data.applicationID = this.ApplicationService.getFamilyData().edit_sums.applicationID;
        putData.Retire = data.Retire;
        putData.Equity = data.Equity;
        putData.Thresh_Assets_Cap = data.Thresh_Assets_Cap;
        putData.Thresh_Assets_Percent = data.Thresh_Assets_Percent;

        return this.$http.put("/api/family/" + data.familyID + '/familyThresholds/' + data.applicationID, data).success(function(data, status, headers, config) {
                    self.CalculationService.reCalc();
                    instance.options.callMe(data, status, headers, config, instance);
            });
    },
    successSave: function(scope, instance, callback) 
    {
        instance.stop(1);
        if (typeof callback !== 'undefined')
            callback();  
    }
});

stateProviders.push({
    name: 'schoolside.application.awardCalculation.imputedIncome',
    url: '/imputedIncome',
    templateUrl: 'fast/submodules/schoolside/applications/mainContent/tabs/awardCalculation/rightAwardCalculation/imputedIncome/imputedIncome.html?v=' + versionNo,
    controller: 'ImputedIncomeController'
});
